export const BILANCIO_TEAMSYSTEM_ACCOUNT_REGEX =
  /^(?:\d{2}\/\d{4}|\d{2}\/\d{2}\/\d{3})$/;

export function isBilancioTeamSystemAccountCode(value) {
  return BILANCIO_TEAMSYSTEM_ACCOUNT_REGEX.test(String(value || "").trim());
}

export function formatBilancioTeamSystemAccountCode(value) {
  const digits = String(value || "")
    .replace(/\D/g, "")
    .slice(0, 7);

  if (digits.length <= 2) return digits;
  if (digits.length <= 6) {
    return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  }
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}
